"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.odsApiConfig = void 0;
const env_1 = require("../env/env");
const ODS_API_URL = env_1.env.getString('ODS_API_URL') || 'http://localhost:8000/public-api';
exports.odsApiConfig = {
    COMMUNICATION_PREFERENCES_URL: `${ODS_API_URL}/communication-preferences/`,
    COMMUNICATION_CHANNELS_URL: `${ODS_API_URL}/communication-channels/`,
};
//# sourceMappingURL=odsApiConfig.js.map